import Vue from 'vue';
import Router from 'vue-router';

import Authentication from '@/components/pages/Authentication';
import EmployeesList from '@/components/pages/EmployeesList';
import ArchivedEmployeesList from '@/components/pages/ArchivedEmployeesList';
import Employee from '@/components/pages/Employee';
import EmployeeRoles from '@/components/pages/EmployeeRoles';
import EmployeeViewMobile from '@/components/adaptive/employee-view-mobile';
import Settings from '@/components/pages/Settings';
import NotFound from '@/components/pages/NotFound';

import AuthService from '../services/AuthService';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'Authentication',
            component: Authentication,
            meta: {
                title: 'Authentication | AIS Login'
            }
        },
        {
            path: '/',
            redirect: '/employees'
        },
        {
            path: '/employees',
            name: 'Employees',
            component: EmployeesList,
            title: 'Employees',
            icon: 'mdi-account',
            beforeEnter: authRequired,
            meta: {
                showInMenu: true,
                title: 'Employees | AIS Login',
                selectedForRoutes: [
                    'EmployeeEdit',
                    'EmployeeViewMobile',
                    'EmployeeAddNew'
                ]
            },
            props: true
        },
        {
            path: '/edit/:userId',
            name: 'EmployeeEdit',
            component: Employee,
            beforeEnter: authRequired,
            meta: {
                showInMenu: false,
                title: 'Edit employee | AIS Login'
            }
        },
        {
            path: '/view/:userId',
            name: 'EmployeeViewMobile',
            component: EmployeeViewMobile,
            beforeEnter: authRequired,
            meta: {
                showInMenu: false,
                title: 'View employee | AIS Login'
            }
        },
        {
            path: '/add',
            name: 'EmployeeAddNew',
            component: Employee,
            beforeEnter: authRequired,
            meta: {
                showInMenu: false,
                title: 'Add employee | AIS Login'
            }
        },
        {
            path: '/roles',
            name: 'EmployeeRoles',
            component: EmployeeRoles,
            title: 'Roles',
            icon: 'mdi-account-switch',
            beforeEnter: authRequired,
            meta: {
                showInMenu: false,
                title: 'Roles | AIS Login'
            }
        },
        {
            path: '/settings',
            name: 'Settings',
            component: Settings,
            title: 'Settings',
            icon: 'mdi-settings',
            beforeEnter: authRequired,
            meta: {
                showInMenu: true,
                title: 'Settings | AIS Login'
            }
        },
        {
            path: '/archive',
            name: 'Archive',
            component: ArchivedEmployeesList,
            title: 'Archive',
            icon: 'mdi-folder-account',
            beforeEnter: authRequired,
            meta: {
                showInMenu: true,
                title: 'Archive | AIS Login',
                selectedForRoutes: [
                    'EmployeeArchiveEdit',
                    'EmployeeArchiveViewMobile'
                ]
            }
        },
        {
            path: '/archivedEdit/:userId',
            name: 'EmployeeArchiveEdit',
            component: Employee,
            beforeEnter: authRequired,
            meta: {
                showInMenu: false,
                title: 'Edit employee | AIS Login'
            }
        },
        {
            path: '/archivedView/:userId',
            name: 'EmployeeArchiveViewMobile',
            component: EmployeeViewMobile,
            beforeEnter: authRequired,
            meta: {
                showInMenu: false,
                title: 'View employee | AIS Login'
            }
        },
        {
            path: '*',
            name: 'NotFound',
            component: NotFound,
            beforeEnter: authRequired,
            meta: {
                showInMenu: false,
                title: 'Not Found | AIS Login'
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
});

function authRequired(to, from, next) {
    if (AuthService.isUserAuthenticated() && AuthService.isAdmin()) {
        next();
    } else {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
    }
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js